export const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
];

// Max ~10 MB for image uploads
export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;

export const MAX_ADDITIONAL_PHOTOS = 3;
